<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">운영보고서</span>
            <span class="txt">기존 데이터에서 중요한 정보를 한눈에 확인할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button class="on">월간 보고서</button>
            <button @click="onClickRouter('/madmin/stats/period')">기간별 보고서</button>
            <button @click="onClickRouter('/madmin/stats/year')">연간 보고서</button>
        </div>

        <div class="com-search-content">
            <div class="line">
                <select-form
                    :select-data="[...yearList]"
                    :select-value="[...yearValueList]"
                    :selected-value="yearDate"
                    class="w130"
                    @update:set="(val) => (yearDate = val)"
                ></select-form>
                <select-form
                    :select-data="[...monthList]"
                    :select-value="[...monthValueList]"
                    :selected-value="startDate"
                    class="w100"
                    @update:set="(val) => (startDate = val)"
                ></select-form>
                <div class="right">
                    <button class="com-btn excel" @click="execlDownload">엑셀 다운로드</button>
                </div>
            </div>
        </div>

        <div class="com-table-top">
            <p class="sub-title bold">상담</p>
            <table class="com-table w900">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>전화</th>
                        <th>방문</th>
                        <th>기타</th>
                        <th>총 상담 수</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>당월</strong></td>
                        <td>{{ consult.thisMonth.tel }}</td>
                        <td>{{ consult.thisMonth.visit }}</td>
                        <td>{{ consult.thisMonth.etc }}</td>
                        <td>
                            <strong>{{ consultTotal2 }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>전월</strong></td>
                        <td>{{ consult.prevMonth.tel }}</td>
                        <td>{{ consult.prevMonth.visit }}</td>
                        <td>{{ consult.prevMonth.etc }}</td>
                        <td>
                            <strong>{{ consultTotal }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top profit">
            <p class="sub-title bold">매출</p>
            <span class="title">
                전체 수익 현황
                <div class="com-tooltip right">
                    도움말
                    <button class="icon"></button>
                    <div class="detail big">
                        <div class="division-wrap">
                            <div class="info-area">
                                <span class="tit">소진금액</span>
                                <p class="txt">1회당 단가 x 사용횟수</p>
                                <span class="tit">잔여금액</span>
                                <p class="txt">
                                    해당 직원이 담당강사로 배정 된 유효 회원의 구매가에서
                                    <br />
                                    소진금액을 제외하고 남은 누적잔여금액의 총 합계.
                                    <br />
                                    <br />

                                    예시)
                                    <br />
                                    결제금액 : 10회 500,000원
                                    <br />
                                    회당 단가 50,000원
                                    <br />
                                    수업 3회 사용완료인 경우
                                    <br />
                                    소진매출 : 150,000원
                                    <br />
                                    잔여금액 : 350,000원
                                </p>
                                <p class="txt red">
                                    ※ 소진금액, 잔여금액은 이용권의 횟수가 정해져 있는 '총 N회'인 이용권의 합계입니다.
                                    주 N회/무제한 횟수의 이용권은 정확한 금액을 환산할 수 없으므로 산출하지 않습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </span>
            <table class="com-table w900">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>이용권 수입</th>
                        <th>일반수입</th>
                        <th>환불</th>
                        <th class="gray">매출합계</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>당월</strong></td>
                        <td>{{ price.thisMonth.ticketIncome | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.income | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.refund | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ saleTotalThisMonth | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>전월</strong></td>
                        <td>{{ price.prevMonth.ticketIncome | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.income | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.refund | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ saleTotalPrevMonth | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="com-table w1080">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>고정지출</th>
                        <th>변동지출</th>
                        <th>급여</th>
                        <th class="gray">지출합계</th>
                        <th class="blue">영업이익</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>당월</strong></td>
                        <td>{{ price.thisMonth.fix | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.var | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.salary | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ saleTotalThisMonth1 | numberFormatFilter }}</strong>
                        </td>
                        <td>
                            <strong>{{ thisMonthRealPrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>전월</strong></td>
                        <td>{{ price.prevMonth.fix | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.var | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.salary | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ saleTotalPrevMonth1 | numberFormatFilter }}</strong>
                        </td>
                        <td>
                            <strong>{{ prevMonthRealPrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="com-table w540">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th class="blue"></th>
                        <th class="blue">이용권 소진금액</th>
                        <th class="blue">이용권 잔여금액</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>당월</strong></td>
                        <td>{{ price.thisMonth.used | numberFormatFilter }}</td>
                        <td>{{ price.thisMonth.remain | numberFormatFilter }}</td>
                    </tr>
                    <tr>
                        <td><strong>전월</strong></td>
                        <td>{{ price.prevMonth.used | numberFormatFilter }}</td>
                        <td>{{ price.prevMonth.remain | numberFormatFilter }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">신규 / 재등록 현황</span>
            <table class="com-table w900">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>신규건수</th>
                        <th>신규매출</th>
                        <th>재등록건수</th>
                        <th>재등록매출</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>당월</strong></td>
                        <td>{{ contractType.thisMonth.newContract }}</td>
                        <td>{{ contractType.thisMonth.newPrice | numberFormatFilter }}</td>
                        <td>{{ contractType.thisMonth.reContract }}</td>
                        <td>
                            <strong>{{ contractType.thisMonth.rePrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>전월</strong></td>
                        <td>{{ contractType.prevMonth.newContract }}</td>
                        <td>{{ contractType.prevMonth.newPrice | numberFormatFilter }}</td>
                        <td>{{ contractType.prevMonth.reContract }}</td>
                        <td>
                            <strong>{{ contractType.prevMonth.rePrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">
                결제수단별 상품매출
                <small>(이용권 수입 + 일반 수업)</small>
            </span>
            <table class="com-table layout-fixed">
                <thead>
                    <tr>
                        <th></th>
                        <th>핏페이</th>
                        <th>카드</th>
                        <th>현금</th>
                        <th>계좌</th>
                        <th>기타</th>
                        <th class="gray">합계</th>
                        <th>마일리지 사용</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>당월</strong></td>
                        <td>{{ payType.thisMonth.fitpay | numberFormatFilter }}</td>
                        <td>{{ payType.thisMonth.card | numberFormatFilter }}</td>
                        <td>{{ payType.thisMonth.cash | numberFormatFilter }}</td>
                        <td>{{ payType.thisMonth.bank | numberFormatFilter }}</td>
                        <td>{{ payType.thisMonth.etc | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ payTypeTotal2 | numberFormatFilter }}</strong>
                        </td>
                        <td>{{ payType.thisMonth.mileage | numberFormatFilter }}</td>
                    </tr>
                    <tr>
                        <td><strong>전월</strong></td>
                        <td>{{ payType.prevMonth.fitpay | numberFormatFilter }}</td>
                        <td>{{ payType.prevMonth.card | numberFormatFilter }}</td>
                        <td>{{ payType.prevMonth.cash | numberFormatFilter }}</td>
                        <td>{{ payType.prevMonth.bank | numberFormatFilter }}</td>
                        <td>{{ payType.prevMonth.etc | numberFormatFilter }}</td>
                        <td>
                            <strong>{{ payTypeTotal | numberFormatFilter }}</strong>
                        </td>
                        <td>{{ payType.prevMonth.mileage | numberFormatFilter }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">이용권 구분별 매출현황</span>
            <table class="com-table">
                <colgroup>
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th>개인</th>
                        <th>듀엣</th>
                        <th>오티</th>
                        <th>그룹</th>
                        <th>쿠폰</th>
                        <th>회원권</th>
                        <th>운동복</th>
                        <!-- <th>패키지</th> -->
                        <th class="gray">합계</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>당월</strong></td>
                        <td>{{ ticketType.thisMonth.person | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.duet | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.ot | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.group | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.coupon | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.ticket | numberFormatFilter }}</td>
                        <td>{{ ticketType.thisMonth.sport | numberFormatFilter }}</td>
                        <!-- <td>{{ticketType.thisMonth.pakage | numberFormatFilter}}</td> -->
                        <td>
                            <strong>{{ ticketType.thisMonth.totalPrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>전월</strong></td>
                        <td>{{ ticketType.prevMonth.person | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.duet | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.ot | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.group | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.coupon | numberFormatFilter }}</td>
                        <td>{{ ticketType.prevMonth.ticket | numberFormatFilter }}</td>
                        <!-- <td>{{ticketType.prevMonth.pakage | numberFormatFilter}}</td> -->
                        <td>
                            <strong>{{ ticketType.prevMonth.totalPrice | numberFormatFilter }}</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="com-table-top">
            <span class="title">환불현황</span>
            <table class="com-table">
                <colgroup>
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                    <col style="width: 340px" />
                    <col style="width: 120px" />
                    <col style="width: 220px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>회원명</th>
                        <th>담당강사</th>
                        <th>매출직원</th>
                        <th>환불 신청일</th>
                        <th>환불 완료일</th>
                        <th>상품명</th>
                        <th>환불 금액</th>
                        <th>환불 사유</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(r, index) in returnList" :key="index">
                        <td>{{ r.ccp_customer_nm }}</td>
                        <td>{{ r.ccp_less_staff_nm }}</td>
                        <td>{{ r.ccp_sale_staff_nm }}</td>
                        <td>{{ r.ccp_ret_apply_dt | timestampFilter }}</td>
                        <td>{{ r.ccp_ret_exec_dt | timestampFilter }}</td>
                        <td>{{ r.ccp_prod_nm }}</td>
                        <td>{{ r.ccp_ret_price | numberFormatFilter }}</td>
                        <td>{{ r.ccp_ret_memo }}</td>
                    </tr>
                    <!-- <tr>
                    <td>김하연</td>
                    <td>김윤경</td>
                    <td>김하연</td>
                    <td>2020-02-03</td>
                    <td>2020-02-03</td>
                    <td>1:1 PT 10회</td>
                    <td>700,000</td>
                    <td>회사이직</td>
                </tr> -->
                </tbody>
            </table>
            <p class="sub-title bold">직원</p>
            <div class="check-line">
                <div class="com-check">
                    <input
                        id="select-check-1-1"
                        v-model="sign"
                        name="select-check-1"
                        type="checkbox"
                        value="I"
                        @change="onMonthStaffBill"
                    />
                    <label for="select-check-1-1">근무중인 직원</label>
                </div>
                <div class="com-check">
                    <input
                        id="select-check-1-2"
                        v-model="resign"
                        name="select-check-1"
                        type="checkbox"
                        value="O"
                        @change="onMonthStaffBill"
                    />
                    <label for="select-check-1-2">퇴사한 직원</label>
                </div>
                <div class="com-tooltip right">
                    도움말
                    <button class="icon"></button>
                    <div class="detail big gap">
                        <div class="division-wrap">
                            <div class="info-area">
                                <span class="tit">소진금액</span>
                                <p class="txt">1회당 단가 x 사용횟수</p>
                                <span class="tit">잔여금액</span>
                                <p class="txt">
                                    해당 직원이 담당강사로 배정 된 유효 회원의 구매가에서
                                    <br />
                                    소진금액을 제외하고 남은 누적잔여금액의 총 합계.
                                </p>
                                <span class="tit">유효건수</span>
                                <p class="txt">해당직원이 ‘담당강사’로 선택된 이용권 중 유효한 이용권 건수</p>
                                <span class="tit">종료건수</span>
                                <p class="txt">
                                    해당직원이 ‘담당강사’로 선택된 이용권 중 해당 기간에
                                    <br />
                                    종료된 이용권 건수 (종료 후 재등록 여부와는 상관 없음)
                                </p>
                                <p class="txt red">
                                    ※ 소진금액, 잔여금액은 이용권의 횟수가 정해져 있는 '총 N회'인 이용권의 합계입니다.
                                    주 N회/무제한 횟수의 이용권은 정확한 금액을 환산할 수 없으므로 산출하지 않습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 100px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 180px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>직원명</th>
                        <th>총 매출</th>
                        <th>신규매출</th>
                        <th>재등록 매출</th>
                        <th>소진금액</th>
                        <th>잔여금액</th>
                        <th>유효건수</th>
                        <th>종료건수</th>
                        <th>신규건수</th>
                        <th>재등록 건수</th>
                        <th>총 수업 수</th>
                        <th>차인 지급액</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(s, index) in staffStatList" :key="index">
                        <td>{{ s.csbb_center_staff_nm }}</td>
                        <td>{{ s.csbb_total_sale_price | numberFormatFilter }}</td>
                        <td>{{ s.csbb_sale_new_price | numberFormatFilter }}</td>
                        <td>{{ s.csbb_sale_renew_price | numberFormatFilter }}</td>
                        <td>{{ s.csbb_tick_use_price | numberFormatFilter }}</td>
                        <td>{{ s.csbb_real_sale_price | numberFormatFilter }}</td>
                        <td>{{ s.csbb_less_valid_cnt }}</td>
                        <td>{{ s.csbb_less_finish_cnt }}</td>
                        <td>{{ s.csbb_sale_new_cnt }}</td>
                        <td>{{ s.csbb_sale_renew_cnt }}</td>
                        <td>{{ s.csbb_less_total_cnt }}</td>
                        <td>{{ s.csbb_real_sale_price | numberFormatFilter }}</td>
                    </tr>
                    <tr class="total border">
                        <td>합계</td>
                        <td>{{ totalSalePrice | numberFormatFilter }}</td>
                        <td>{{ saleNewPrice | numberFormatFilter }}</td>
                        <td>{{ saleRenewPrice | numberFormatFilter }}</td>
                        <td>{{ tickUsePrice | numberFormatFilter }}</td>
                        <td>{{ realSalePrice | numberFormatFilter }}</td>
                        <td>{{ lessValidCnt }}</td>
                        <td>{{ lessFinishCnt }}</td>
                        <td>{{ saleNewCnt }}</td>
                        <td>{{ saleRenewCnt }}</td>
                        <td>{{ lessTotalCnt }}</td>
                        <td>{{ totalRealSalePrice | numberFormatFilter }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import XLSX from 'xlsx';
import { numberFormat, timestampToDate } from '@/assets/js/excelCommon.js';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'StatsMonth',
    props: {},
    computed: {
        payTypeTotal() {
            return (
                this.payType.prevMonth.fitpay +
                this.payType.prevMonth.card +
                this.payType.prevMonth.cash +
                this.payType.prevMonth.bank +
                this.payType.prevMonth.etc +
                this.payType.prevMonth.mileage
            );
        },
        payTypeTotal2() {
            return (
                this.payType.thisMonth.fitpay +
                this.payType.thisMonth.card +
                this.payType.thisMonth.cash +
                this.payType.thisMonth.bank +
                this.payType.thisMonth.etc +
                this.payType.thisMonth.mileage
            );
        },
        consultTotal() {
            return (
                parseInt(this.consult.prevMonth.tel) +
                parseInt(this.consult.prevMonth.visit) +
                parseInt(this.consult.prevMonth.etc)
            );
        },
        consultTotal2() {
            return (
                parseInt(this.consult.thisMonth.tel) +
                parseInt(this.consult.thisMonth.visit) +
                parseInt(this.consult.thisMonth.etc)
            );
        },
        saleTotalThisMonth() {
            // 매출당월
            return (
                parseInt(this.price.thisMonth.ticketIncome) +
                parseInt(this.price.thisMonth.income) +
                parseInt(this.price.thisMonth.refund)
            );
        },
        saleTotalThisMonth1() {
            // 매출전월
            return (
                parseInt(this.price.thisMonth.fix) +
                parseInt(this.price.thisMonth.var) +
                parseInt(this.price.thisMonth.salary)
            );
        },
        saleTotalPrevMonth() {
            // 매출당월
            return (
                parseInt(this.price.prevMonth.ticketIncome) +
                parseInt(this.price.prevMonth.income) +
                parseInt(this.price.prevMonth.refund)
            );
        },
        saleTotalPrevMonth1() {
            // 매출전월
            return (
                parseInt(this.price.prevMonth.fix) +
                parseInt(this.price.prevMonth.var) +
                parseInt(this.price.prevMonth.salary)
            );
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        totalSalePrice() {
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_total_sale_price);
            }
            return result;
        },

        saleNewPrice() {
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_sale_new_price);
            }
            return result;
        },
        saleRenewPrice() {
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_sale_renew_price);
            }
            return result;
        },
        tickUsePrice() {
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_tick_use_price);
            }
            return result;
        },
        realSalePrice() {
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_real_sale_price);
            }
            return result;
        },
        totalRealSalePrice() {
            // 차인지급액
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_real_sale_price);
            }
            return result;
        },
        // 유효건수
        lessValidCnt() {
            // 유효건수
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_less_valid_cnt);
            }
            return result;
        },
        // 종료건수
        lessFinishCnt() {
            // 종료건수
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_less_finish_cnt);
            }
            return result;
        },
        // 신규건수
        saleNewCnt() {
            // 차인지급액
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_sale_new_cnt);
            }
            return result;
        },
        // 재등록건수
        saleRenewCnt() {
            // 차인지급액
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_sale_renew_cnt);
            }
            return result;
        },
        // 총수업수
        lessTotalCnt() {
            // 차인지급액
            let result = 0;
            for (const s of this.staffStatList) {
                result += parseInt(s.csbb_less_total_cnt);
            }
            return result;
        },
        thisMonthRealPrice() {
            return this.saleTotalThisMonth - this.saleTotalThisMonth1;
        },
        prevMonthRealPrice() {
            return this.saleTotalPrevMonth - this.saleTotalPrevMonth1;
        },
    },
    watch: {
        yearDate(newValue) {
            this.yearDate = newValue;
            console.log(this.yearDate);
            this.init();
        },
        startDate(newValue) {
            this.startDate = newValue;
            console.log(this.startDate);
            this.init();
        },
    },
    data() {
        return {
            centerId: '',
            pagingInfo: { ...pagingInfo },
            monthList: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            monthValueList: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
            yearList: [],
            yearValueList: [],
            startDate: moment().format('MM'),
            yearDate: moment().format('YYYY'),
            statsMonth: '',
            tel: '',
            visit: '',
            etc: '',
            newContract: '',
            buyPrice: '',
            reContract: '',
            reBuyPrice: '',

            ticketType: {
                prevMonth: {
                    person: 0,
                    duet: 0,
                    ot: 0,
                    group: 0,
                    coupon: 0,
                    ticket: 0,
                    totalPrice: 0,
                },
                thisMonth: {
                    person: 0,
                    duet: 0,
                    ot: 0,
                    group: 0,
                    coupon: 0,
                    ticket: 0,
                    totalPrice: 0,
                },
            },
            payType: {
                prevMonth: {
                    fitpay: 0,
                    card: 0,
                    cash: 0,
                    bank: 0,
                    etc: 0,
                    mileage: 0,
                },
                thisMonth: {
                    fitpay: 0,
                    card: 0,
                    cash: 0,
                    bank: 0,
                    etc: 0,
                    mileage: 0,
                },
            },
            contractType: {
                prevMonth: {
                    newContract: 0,
                    newPrice: 0,
                    reContract: 0,
                    rePrice: 0,
                },
                thisMonth: {
                    newContract: 0,
                    newPrice: 0,
                    reContract: 0,
                    rePrice: 0,
                },
            },
            consult: {
                prevMonth: {
                    tel: 0,
                    visit: 0,
                    etc: 0,
                },
                thisMonth: {
                    tel: 0,
                    visit: 0,
                    etc: 0,
                },
            },
            price: {
                prevMonth: {
                    // 이용권수입
                    ticketIncome: 0,
                    // 일반수입
                    income: 0,
                    // 환불
                    refund: 0,
                    // 고정지출
                    fix: 0,
                    // 변동지출
                    var: 0,
                    // 급여
                    salary: 0,
                    // 영업이익
                    sale: 0,
                    // 이용권소진금액
                    used: 0,
                    // 이용권잔여금액
                    remain: 0,
                },
                thisMonth: {
                    // 이용권수입
                    ticketIncome: 0,
                    // 일반수입
                    income: 0,
                    // 환불
                    refund: 0,
                    // 고정지출
                    fix: 0,
                    // 변동지출
                    var: 0,
                    // 급여
                    salary: 0,
                    // 영업이익
                    sale: 0,
                    // 이용권소진금액
                    used: 0,
                    // 이용권잔여금액
                    remain: 0,
                },
            },

            billStatus: 'T', // 직원통계 조회를 위한 기본값 radio값에 의해 변경
            staffStatList: [],
            sign: true,
            resign: true,
            returnList: [],
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.init();
    },
    methods: {
        // 초기화
        async init() {
            try {
                await this.onMonthConsult(); // 상담조회(이번달)
                await this.onMonthConsultType(); // 신규재등록조회(이번달)
                await this.onMonthPayType();
                await this.onMonthTicketType();
                await this.onMonthStaffBill();
                await this.onMonthSaleStat();
                await this.onReturnStat();

                // 년도 자동생성
                for (let i = 0; i < 6; i++) {
                    this.yearList.push(moment().subtract(i, 'y').format('YYYY년'));
                    this.yearValueList.push(moment().subtract(i, 'y').format('YYYY'));
                }
            } catch (error) {
                console.log(error);
                console.log('초기화 오류입니다.');
            }
        },
        // 상담조회
        async onMonthConsult() {
            try {
                const { data } = await this.getMonthConsult(this.yearDate, this.startDate); // 이번달 요청
                console.log('이번달 상담조회 데이터', data);

                const monthObj = {};

                for (const d of data) {
                    const key = d.cc_stats_month;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            tel: 0,
                            visit: 0,
                            etc: 0,
                            total: 0,
                        };
                    }

                    switch (d.cc_consult_path) {
                        case 'T':
                            monthObj[key].tel += parseInt(d.cc_consult_cnt);
                            break;
                        case 'V':
                            monthObj[key].visit += parseInt(d.cc_consult_cnt);
                            break;
                        case 'E':
                            monthObj[key].etc += parseInt(d.cc_consult_cnt);
                            break;
                    }

                    monthObj[key].total += parseInt(d.cc_consult_cnt);
                }

                console.log('====> monthobj', monthObj);

                const keys = Object.keys(monthObj).sort();

                const consult = [];
                for (const k of keys) {
                    consult.push(monthObj[k]);
                }
                console.log('====> consult', consult);

                // 초기화
                this.consult.thisMonth.tel = 0;
                this.consult.thisMonth.visit = 0;
                this.consult.thisMonth.etc = 0;
                this.consult.prevMonth.tel = 0;
                this.consult.prevMonth.visit = 0;
                this.consult.prevMonth.etc = 0;

                consult.forEach((g) => {
                    console.log('und', g.month);
                    console.log(moment(this.yearDate + this.startDate).format('YYYY-MM'));
                    if (g.month == moment(this.yearDate + this.startDate).format('YYYY-MM')) {
                        this.consult.thisMonth.tel = g.tel;
                        this.consult.thisMonth.visit = g.visit;
                        this.consult.thisMonth.etc = g.etc;
                    } else if (
                        g.month ==
                        moment(this.yearDate + this.startDate)
                            .subtract(1, 'months')
                            .format('YYYY-MM')
                    ) {
                        this.consult.prevMonth.tel = g.tel;
                        this.consult.prevMonth.visit = g.visit;
                        this.consult.prevMonth.etc = g.etc;
                    }
                });
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        // 상담조회 api
        getMonthConsult(year, month) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/month/consult`, {
                params: {
                    statsYear: year,
                    statsMonth: month,
                },
            });
        },
        // 신규 재등록 현황 조회
        async onMonthConsultType() {
            try {
                const { data } = await this.getMonthConsultType(this.yearDate, this.startDate);
                console.log('신규 재등록조회', data);

                const monthObj = {};

                for (const d of data) {
                    const key = d.cc_buy_dt;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            newContract: 0,
                            newPrice: 0,
                            reContract: 0,
                            rePrice: 0,
                        };
                    }

                    switch (d.cc_contract_type_cd) {
                        case 'N':
                            monthObj[key].newContract += parseInt(d.cc_contract_type_cd_cnt);
                            monthObj[key].newPrice += parseInt(d.cc_total_buy_price);
                            break;
                        case 'R':
                            monthObj[key].reContract += parseInt(d.cc_contract_type_cd_cnt);
                            monthObj[key].rePrice += parseInt(d.cc_total_buy_price);
                            break;
                    }

                    // monthObj[key].total += parseInt(d.cc_consult_cnt);
                }

                console.log('====> monthobj', monthObj);

                const keys = Object.keys(monthObj).sort();

                const contractType = [];
                for (const k of keys) {
                    contractType.push(monthObj[k]);
                }
                console.log('====> consult', contractType);

                // 값 초기화
                this.contractType.thisMonth.newContract = 0;
                this.contractType.thisMonth.newPrice = 0;
                this.contractType.thisMonth.reContract = 0;
                this.contractType.thisMonth.rePrice = 0;
                this.contractType.prevMonth.newContract = 0;
                this.contractType.prevMonth.newPrice = 0;
                this.contractType.prevMonth.reContract = 0;
                this.contractType.prevMonth.rePrice = 0;

                contractType.forEach((g) => {
                    console.log('und', g.month);
                    console.log(moment(this.yearDate + this.startDate).format('YYYY-MM'));
                    if (g.month == moment(this.yearDate + this.startDate).format('YYYY-MM')) {
                        this.contractType.thisMonth.newContract = g.newContract;
                        this.contractType.thisMonth.newPrice = g.newPrice;
                        this.contractType.thisMonth.reContract = g.reContract;
                        this.contractType.thisMonth.rePrice = g.rePrice;
                    } else if (
                        g.month ==
                        moment(this.yearDate + this.startDate)
                            .subtract(1, 'months')
                            .format('YYYY-MM')
                    ) {
                        this.contractType.prevMonth.newContract = g.newContract;
                        this.contractType.prevMonth.newPrice = g.newPrice;
                        this.contractType.prevMonth.reContract = g.reContract;
                        this.contractType.prevMonth.rePrice = g.rePrice;
                    }
                });
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        // 신규 재등록조회 api
        getMonthConsultType(year, month) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/month/contract-type`, {
                params: {
                    statsYear: year,
                    statsMonth: month,
                },
            });
        },
        // 결제수단별 상품매출 조회
        async onMonthPayType() {
            try {
                const { data } = await this.getMonthPayType(this.yearDate, this.startDate);
                console.log('결제수단 조회', data);

                const monthObj = {};

                for (const d of data) {
                    const key = d.ccb_buy_dt;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            card: 0,
                            cash: 0,
                            bank: 0,
                            etc: 0,
                            mileage: 0,
                            fitpay: 0,
                        };
                    }

                    switch (d.ccb_pay_type_cd) {
                        case 'C':
                            monthObj[key].card += parseInt(d.ccb_bill_price);
                            break;
                        case 'L':
                            monthObj[key].cash += parseInt(d.ccb_bill_price);
                            break;
                        case 'B':
                            monthObj[key].bank += parseInt(d.ccb_bill_price);
                            break;
                        case 'E':
                            monthObj[key].etc += parseInt(d.ccb_bill_price);
                            break;
                        case 'M':
                            monthObj[key].mileage += parseInt(d.ccb_bill_price);
                            break;
                        case 'T':
                        case 'U':
                            monthObj[key].fitpay += parseInt(d.ccb_bill_price);
                            break;
                    }

                    // monthObj[key].total += parseInt(d.cc_consult_cnt);
                }

                console.log('====> monthobj', monthObj);

                const keys = Object.keys(monthObj).sort();

                const payType = [];
                for (const k of keys) {
                    payType.push(monthObj[k]);
                }
                console.log('====> payType', payType);

                // 초기화
                this.payType.thisMonth.card = 0;
                this.payType.thisMonth.cash = 0;
                this.payType.thisMonth.bank = 0;
                this.payType.thisMonth.etc = 0;
                this.payType.thisMonth.mileage = 0;
                this.payType.thisMonth.fitpay = 0;
                this.payType.prevMonth.card = 0;
                this.payType.prevMonth.cash = 0;
                this.payType.prevMonth.bank = 0;
                this.payType.prevMonth.etc = 0;
                this.payType.prevMonth.mileage = 0;
                this.payType.prevMonth.fitpay = 0;

                payType.forEach((g) => {
                    console.log('und', g.month);
                    console.log(moment(this.yearDate + this.startDate).format('YYYY-MM'));
                    if (g.month == moment(this.yearDate + this.startDate).format('YYYY-MM')) {
                        this.payType.thisMonth.card = g.card;
                        this.payType.thisMonth.cash = g.cash;
                        this.payType.thisMonth.bank = g.bank;
                        this.payType.thisMonth.etc = g.etc;
                        this.payType.thisMonth.mileage = g.mileage;
                        this.payType.thisMonth.fitpay = g.fitpay;
                    } else if (
                        g.month ==
                        moment(this.yearDate + this.startDate)
                            .subtract(1, 'months')
                            .format('YYYY-MM')
                    ) {
                        this.payType.prevMonth.card = g.card;
                        this.payType.prevMonth.cash = g.cash;
                        this.payType.prevMonth.bank = g.bank;
                        this.payType.prevMonth.etc = g.etc;
                        this.payType.prevMonth.mileage = g.mileage;
                        this.payType.prevMonth.fitpay = g.fitpay;
                    }
                });
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        // 결제수단 조회 api
        getMonthPayType(year, month) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/month/pay-type`, {
                params: {
                    statsYear: year,
                    statsMonth: month,
                },
            });
        },
        // 이용권 구분별 매출 현황 조회
        async onMonthTicketType() {
            try {
                const { data } = await this.getMonthTicketType(this.yearDate, this.startDate);
                console.log('이용권조회', data);

                const monthObj = {};

                for (const d of data) {
                    const key = d.ccp_buy_dt;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            person: 0,
                            duet: 0,
                            ot: 0,
                            group: 0,
                            coupon: 0,
                            ticket: 0,
                        };
                    }

                    switch (d.ccp_ticket_type_cd) {
                        case 'P': // 개인
                            monthObj[key].person += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'D': // 듀엣
                            monthObj[key].duet += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'G': // 그룹
                            monthObj[key].group += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'O': // 오티
                            monthObj[key].ot += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'C': // 쿠폰
                            monthObj[key].coupon += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'T': // 회원권
                            monthObj[key].ticket += parseInt(d.ccp_total_bill_price);
                            break;
                        case 'S': // 운동복
                            monthObj[key].sport += parseInt(d.ccp_total_bill_price);
                            break;
                    }

                    // monthObj[key].total += parseInt(d.cc_consult_cnt);
                }

                console.log('====> monthobj', monthObj);

                const keys = Object.keys(monthObj).sort();

                const ticketType = [];
                for (const k of keys) {
                    ticketType.push(monthObj[k]);
                }
                console.log('====> ticketType', ticketType);

                // 초기화
                this.ticketType.thisMonth.person = 0;
                this.ticketType.thisMonth.duet = 0;
                this.ticketType.thisMonth.group = 0;
                this.ticketType.thisMonth.ot = 0;
                this.ticketType.thisMonth.pakage = 0;
                this.ticketType.thisMonth.ticket = 0;
                this.ticketType.prevMonth.person = 0;
                this.ticketType.prevMonth.duet = 0;
                this.ticketType.prevMonth.group = 0;
                this.ticketType.prevMonth.ot = 0;
                this.ticketType.prevMonth.pakage = 0;
                this.ticketType.prevMonth.ticket = 0;
                this.ticketType.prevMonth.totalPrice = 0;
                this.ticketType.thisMonth.totalPrice = 0;

                ticketType.forEach((g) => {
                    console.log('und', g.month);
                    console.log(moment(this.yearDate + this.startDate).format('YYYY-MM'));
                    if (g.month == moment(this.yearDate + this.startDate).format('YYYY-MM')) {
                        this.ticketType.thisMonth.person = parseInt(g.person);
                        this.ticketType.thisMonth.duet = parseInt(g.duet);
                        this.ticketType.thisMonth.group = parseInt(g.group);
                        this.ticketType.thisMonth.ot = parseInt(g.ot);
                        this.ticketType.thisMonth.coupon = parseInt(g.coupon);
                        this.ticketType.thisMonth.ticket = parseInt(g.ticket);
                    } else if (
                        g.month ==
                        moment(this.yearDate + this.startDate)
                            .subtract(1, 'months')
                            .format('YYYY-MM')
                    ) {
                        this.ticketType.prevMonth.person = parseInt(g.person);
                        this.ticketType.prevMonth.duet = parseInt(g.duet);
                        this.ticketType.prevMonth.group = parseInt(g.group);
                        this.ticketType.prevMonth.ot = parseInt(g.ot);
                        this.ticketType.prevMonth.coupon = parseInt(g.coupon);
                        this.ticketType.prevMonth.ticket = parseInt(g.ticket);
                    }
                });

                this.ticketType.prevMonth.totalPrice =
                    this.ticketType.prevMonth.person +
                    this.ticketType.prevMonth.duet +
                    this.ticketType.prevMonth.ot +
                    this.ticketType.prevMonth.group +
                    this.ticketType.prevMonth.coupon +
                    this.ticketType.prevMonth.ticket;

                this.ticketType.thisMonth.totalPrice =
                    this.ticketType.thisMonth.person +
                    this.ticketType.thisMonth.duet +
                    this.ticketType.thisMonth.ot +
                    this.ticketType.thisMonth.group +
                    this.ticketType.thisMonth.coupon +
                    this.ticketType.thisMonth.ticket;
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        // 이용권 조회 api
        getMonthTicketType(year, month) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/month/ticket-type`, {
                params: {
                    statsYear: year,
                    statsMonth: month,
                },
            });
        },
        // 직원급여
        async onMonthStaffBill() {
            try {
                this.billStatus = this.signStatus();
                const { data } = await this.getMonthStaffBill();
                this.staffStatList = data;
                console.log('직원급여', data);
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        // 직원급여 조회 api
        getMonthStaffBill() {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/month/staff-bill`, {
                params: {
                    statsYear: this.yearDate,
                    statsMonth: this.startDate,
                    status: this.billStatus,
                },
            });
        },
        // 매출 조회
        async onMonthSaleStat() {
            try {
                const { data } = await this.getMonthSaleStat(this.yearDate, this.startDate);
                console.log('매출조회', data);

                const monthObj = {};

                for (const d of data) {
                    const key = d.css_sale_year_month;
                    if (monthObj[key] === undefined) {
                        monthObj[key] = {
                            month: key,
                            ticketIncome: 0, // 이용권수입
                            income: 0, // 일반수입
                            refund: 0, // 환불
                            fix: 0, // 고정지출
                            var: 0, // 변동지출
                            salary: 0, // 급여
                            sale: 0, // 영업이익
                            used: 0, // 이용권소진금액
                            remain: 0, // 이용권 잔여금액
                        };
                    }
                    monthObj[key].ticketIncome += parseInt(d.css_tick_price);
                    monthObj[key].income += parseInt(d.css_prod_price);
                    monthObj[key].refund += parseInt(d.css_ret_price);
                    monthObj[key].fix += parseInt(d.css_fix_exp_price);
                    monthObj[key].var += parseInt(d.css_var_exp_price);
                    monthObj[key].salary += parseInt(d.css_pay_price);
                    monthObj[key].sale += parseInt(d.css_oper_profit_cnt);
                    monthObj[key].used += parseInt(d.css_tick_exh_price);
                    monthObj[key].remain += parseInt(d.css_tick_remain_price);

                    // monthObj[key].total += parseInt(d.cc_consult_cnt);
                }

                console.log('====> monthobj', monthObj);

                const keys = Object.keys(monthObj).sort();

                const price = [];
                for (const k of keys) {
                    price.push(monthObj[k]);
                }
                console.log('====> price', price);

                // 이번달 초기화
                this.price.thisMonth.ticketIncome = 0;
                this.price.thisMonth.income = 0;
                this.price.thisMonth.refund = 0;
                this.price.thisMonth.fix = 0;
                this.price.thisMonth.var = 0;
                this.price.thisMonth.salary = 0;
                this.price.thisMonth.sale = 0;
                this.price.thisMonth.used = 0;
                this.price.thisMonth.remain = 0;
                // 전달 초기화
                this.price.prevMonth.ticketIncome = 0;
                this.price.prevMonth.income = 0;
                this.price.prevMonth.refund = 0;
                this.price.prevMonth.fix = 0;
                this.price.prevMonth.var = 0;
                this.price.prevMonth.salary = 0;
                this.price.prevMonth.sale = 0;
                this.price.prevMonth.used = 0;
                this.price.prevMonth.remain = 0;

                price.forEach((g) => {
                    console.log('und', g.month);
                    console.log(moment(this.yearDate + this.startDate).format('YYYY-MM'));
                    if (g.month == moment(this.yearDate + this.startDate).format('YYYYMM')) {
                        this.price.thisMonth.ticketIncome = parseInt(g.ticketIncome);
                        this.price.thisMonth.income = parseInt(g.income);
                        this.price.thisMonth.refund = parseInt(g.refund);
                        this.price.thisMonth.fix = parseInt(g.fix);
                        this.price.thisMonth.var = parseInt(g.var);
                        this.price.thisMonth.salary = parseInt(g.salary);
                        this.price.thisMonth.sale = parseInt(g.sale);
                        this.price.thisMonth.used = parseInt(g.used);
                        this.price.thisMonth.remain = parseInt(g.remain);
                    } else if (
                        g.month ==
                        moment(this.yearDate + this.startDate)
                            .subtract(1, 'months')
                            .format('YYYYMM')
                    ) {
                        this.price.prevMonth.ticketIncome = parseInt(g.ticketIncome);
                        this.price.prevMonth.income = parseInt(g.income);
                        this.price.prevMonth.refund = parseInt(g.refund);
                        this.price.prevMonth.fix = parseInt(g.fix);
                        this.price.prevMonth.var = parseInt(g.var);
                        this.price.prevMonth.salary = parseInt(g.salary);
                        this.price.prevMonth.sale = parseInt(g.sale);
                        this.price.prevMonth.used = parseInt(g.used);
                        this.price.prevMonth.remain = parseInt(g.remain);
                    }
                });
            } catch (error) {
                console.log(error);
                console.log('조회하는데 오류가 발생했습니다.');
            }
        },
        // 매출조회 api
        getMonthSaleStat(year, month) {
            return api.get(`/admin/api/center/${this.centerId}/stats/report/operational/month/sale-stats`, {
                params: {
                    statsYear: year,
                    statsMonth: month,
                },
            });
        },
        // 환불현황 조회
        async onReturnStat() {
            try {
                const { data } = await this.getReturnStat(this.yearDate, this.startDate);
                console.log('환불현황 데이터', data);
                this.returnList = data.items;
            } catch (error) {
                console.log(error);
                console.log('환불현황 오류입니다.');
            }
        },
        // 환불현황 조회 API
        getReturnStat(year, month) {
            return api.get(`/admin/api/center/${this.centerId}/product/retrun`, {
                // 센터회원계약 상품 환불 페이징 목록 조회
                params: {
                    ...this.pagingInfo,
                    startDate: moment(year + month)
                        .startOf('month')
                        .format('YYYYMMDD'), // this.yearDate+this.startDate,
                    endDate: moment(year + month)
                        .endOf('month')
                        .format('YYYYMMDD'), // this.yearDate+this.startDate,
                },
            });
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        signStatus() {
            if (this.sign == true && this.resign == true) {
                this.checkStaff = []; // 초기화처리
                return 'T';
            } else if (this.sign == true) {
                this.checkStaff = []; // 초기화처리
                return 'I';
            } else if (this.resign == true) {
                this.checkStaff = []; // 초기화처리
                return 'O';
            }
        },

        // 월간 보고서 엑셀 다운로드 기능
        execlDownload() {
            const wb = XLSX.utils.book_new();
            const monthReportDataWS = this.getMonthReportDataWS();
            const returnListWS = this.getReturnListWS();
            const staffStatListWS = this.getStaffStatListWS();

            XLSX.utils.book_append_sheet(wb, monthReportDataWS, '월간보고서');
            XLSX.utils.book_append_sheet(wb, returnListWS, '환불현황');
            XLSX.utils.book_append_sheet(wb, staffStatListWS, '직원');
            XLSX.writeFile(wb, '월간보고서.xlsx');
        },

        // 월간 보고서의 세부 내용을 다루는 부분
        getMonthReportDataWS() {
            const excelDownloadArray = [
                ['상담'],
                ['', '전화', '방문', '기타', '총 상담수'],
                [
                    '당월',
                    numberFormat(Number(this.consult.thisMonth.tel)),
                    numberFormat(Number(this.consult.thisMonth.visit)),
                    numberFormat(Number(this.consult.thisMonth.etc)),
                    numberFormat(Number(this.consultTotal2)),
                ],
                [
                    '전월',
                    numberFormat(Number(this.consult.prevMonth.tel)),
                    numberFormat(Number(this.consult.prevMonth.visit)),
                    numberFormat(Number(this.consult.prevMonth.etc)),
                    numberFormat(Number(this.consultTotal)),
                ],
                [],
                ['매출'],
                ['전체 수익 현황'],
                ['', '이용권 수입', '일반수입', '환불', '매출합계'],
                [
                    '당월',
                    numberFormat(Number(this.price.thisMonth.ticketIncome)),
                    numberFormat(Number(this.price.thisMonth.income)),
                    numberFormat(Number(this.price.thisMonth.refund)),
                    numberFormat(Number(this.saleTotalThisMonth)),
                ],
                [
                    '전월',
                    numberFormat(Number(this.price.prevMonth.ticketIncome)),
                    numberFormat(Number(this.price.prevMonth.income)),
                    numberFormat(Number(this.price.prevMonth.refund)),
                    numberFormat(Number(this.saleTotalPrevMonth)),
                ],
                ['', '고정지출', '변동지출', '급여', '지출합계', '영업이익'],
                [
                    '당월',
                    numberFormat(Number(this.price.thisMonth.fix)),
                    numberFormat(Number(this.price.thisMonth.var)),
                    numberFormat(Number(this.price.thisMonth.salary)),
                    numberFormat(Number(this.saleTotalThisMonth1)),
                    numberFormat(Number(this.thisMonthRealPrice)),
                ],
                [
                    '전월',
                    numberFormat(Number(this.price.prevMonth.fix)),
                    numberFormat(Number(this.price.prevMonth.var)),
                    numberFormat(Number(this.price.prevMonth.salary)),
                    numberFormat(Number(this.saleTotalPrevMonth1)),
                    numberFormat(Number(this.prevMonthRealPrice)),
                ],
                ['', '이용권 소진금액', '이용권 잔여금액'],
                [
                    '당월',
                    numberFormat(Number(this.price.thisMonth.used)),
                    numberFormat(Number(this.price.thisMonth.remain)),
                ],
                [
                    '전월',
                    numberFormat(Number(this.price.prevMonth.used)),
                    numberFormat(Number(this.price.prevMonth.remain)),
                ],
                [],
                ['신규 / 재등록 현황'],
                ['', '신규건수', '신규매출', '재등록건수', '재등록매출'],
                [
                    '당월',
                    numberFormat(Number(this.contractType.thisMonth.newContract)),
                    numberFormat(Number(this.contractType.thisMonth.newPrice)),
                    numberFormat(Number(this.contractType.thisMonth.reContract)),
                    numberFormat(Number(this.contractType.thisMonth.rePrice)),
                ],
                [
                    '전월',
                    numberFormat(Number(this.contractType.prevMonth.newContract)),
                    numberFormat(Number(this.contractType.prevMonth.newPrice)),
                    numberFormat(Number(this.contractType.prevMonth.reContract)),
                    numberFormat(Number(this.contractType.prevMonth.rePrice)),
                ],
                [],
                ['결제수단별 상품매출(이용권 수입 + 일반 수입)'],
                ['', '핏페이', '카드', '현금', '계좌', '기타', '합계', '마일리지 사용'],
                [
                    '당월',
                    numberFormat(Number(this.payType.thisMonth.fitpay)),
                    numberFormat(Number(this.payType.thisMonth.card)),
                    numberFormat(Number(this.payType.thisMonth.cash)),
                    numberFormat(Number(this.payType.thisMonth.bank)),
                    numberFormat(Number(this.payType.thisMonth.etc)),
                    numberFormat(Number(this.payTypeTotal2)),
                    numberFormat(Number(this.payType.thisMonth.mileage)),
                ],
                [
                    '전월',
                    numberFormat(Number(this.payType.prevMonth.fitpay)),
                    numberFormat(Number(this.payType.prevMonth.card)),
                    numberFormat(Number(this.payType.prevMonth.cash)),
                    numberFormat(Number(this.payType.prevMonth.bank)),
                    numberFormat(Number(this.payType.prevMonth.etc)),
                    numberFormat(Number(this.payTypeTotal)),
                    numberFormat(Number(this.payType.prevMonth.mileage)),
                ],
                [],
                ['이용권 구분별 매출현황'],
                ['', '개인', '듀엣', '오티', '그룹', '쿠폰', '회원권', '운동복', '패키지', '합계'],
                [
                    '당월',
                    numberFormat(Number(this.ticketType.thisMonth.person)),
                    numberFormat(Number(this.ticketType.thisMonth.duet)),
                    numberFormat(Number(this.ticketType.thisMonth.ot)),
                    numberFormat(Number(this.ticketType.thisMonth.group)),
                    numberFormat(Number(this.ticketType.thisMonth.coupon)),
                    numberFormat(Number(this.ticketType.thisMonth.ticket)),
                    numberFormat(Number(this.ticketType.thisMonth.sport)),
                    numberFormat(Number(this.ticketType.thisMonth.pakage)),
                    numberFormat(Number(this.ticketTypeTotal2)),
                ],
                [
                    '전월',
                    numberFormat(Number(this.ticketType.prevMonth.person)),
                    numberFormat(Number(this.ticketType.prevMonth.duet)),
                    numberFormat(Number(this.ticketType.prevMonth.ot)),
                    numberFormat(Number(this.ticketType.prevMonth.group)),
                    numberFormat(Number(this.ticketType.prevMonth.coupon)),
                    numberFormat(Number(this.ticketType.prevMonth.ticket)),
                    numberFormat(Number(this.ticketType.thisMonth.sport)),
                    numberFormat(Number(this.ticketType.prevMonth.pakage)),
                    numberFormat(Number(this.ticketTypeTotal)),
                ],
            ];

            const dataWS = XLSX.utils.aoa_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];
            dataWS['!cols'] = wscols;

            return dataWS;
        },

        // 환불 현황 Work Sheet 생성하는 함수
        getReturnListWS() {
            const excelDownloadArray = [];
            const wscols = [];

            this.returnList.forEach((r) => {
                const temp = {};
                temp['회원명'] = r.ccp_customer_nm;
                temp['담당강사'] = r.ccp_less_staff_nm;
                temp['매출직원'] = r.ccp_sale_staff_nm;
                temp['환불 신청일'] = timestampToDate(r.ccp_ret_apply_dt);
                temp['환불 완료일'] = timestampToDate(r.ccp_ret_exec_dt);
                temp['상품명'] = r.ccp_prod_nm;
                temp['환불금액'] = numberFormat(Number(r.ccp_ret_price));
                temp['환불사유'] = r.ccp_ret_memo;

                excelDownloadArray.push(temp);
                wscols.push({ wch: 12 });
            });

            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            dataWS['!cols'] = wscols;

            return dataWS;
        },

        // 직원 Work Sheet 생성하는 함수
        getStaffStatListWS() {
            const excelDownloadArray = [];
            const wscols = [];

            this.staffStatList.forEach((s) => {
                const temp = {};
                temp['직원명'] = s.csbb_center_staff_nm;
                temp['총 매출'] = numberFormat(Number(s.csbb_total_sale_price));
                temp['신규매출'] = numberFormat(Number(s.csbb_sale_new_price));
                temp['재등록 매출'] = numberFormat(Number(s.csbb_sale_renew_price));
                temp['소진금액'] = numberFormat(Number(s.csbb_tick_use_price));
                temp['잔여금액'] = numberFormat(Number(s.csbb_real_sale_price));
                temp['유효건수'] = numberFormat(Number(s.csbb_less_valid_cnt));
                temp['종료건수'] = numberFormat(Number(s.csbb_less_finish_cnt));
                temp['신규건수'] = numberFormat(Number(s.csbb_sale_new_cnt));
                temp['재등록 건수'] = numberFormat(Number(s.csbb_sale_renew_cnt));
                temp['총 수업 수'] = numberFormat(Number(s.csbb_less_total_cnt));
                temp['차인 지급액'] = numberFormat(Number(s.csbb_real_sale_price));

                excelDownloadArray.push(temp);
                wscols.push({ wch: 12 });
            });

            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            dataWS['!cols'] = wscols;

            return dataWS;
        },
    },
};
</script>
<style lang="scss"></style>
